import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.0018 7.99967C10.0018 9.10424 9.10636 9.99967 8.00179 9.99967C6.89722 9.99967 6.00179 9.10424 6.00179 7.99967C6.00179 6.89511 6.89722 5.99967 8.00179 5.99967C9.10636 5.99967 10.0018 6.89511 10.0018 7.99967Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.00208 3.33301C5.017 3.33301 2.49014 5.29493 1.64062 7.99965C2.49013 10.7044 5.01699 12.6663 8.0021 12.6663C10.9872 12.6663 13.514 10.7044 14.3636 7.9997C13.5141 5.29495 10.9872 3.33301 8.00208 3.33301Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEye;
